import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';

export const initialState = {
    tableStateData: [] as any[],
    loading: false,
    drawerOpen: false,
    selectedRow: null as any,
};

export const getColumns = (t: any): ExtendedGridColDef[] => [
    {
        field: 'id',
        headerName: t('general.id'),
        flex: 0.5,
        minWidth: 70,
    },
    {
        field: 'tableName',
        headerName: t('studioSyncTableState.tableName'),
        flex: 2,
        minWidth: 220,
    },
    {
        field: 'batchSize',
        headerName: t('studioSyncTableState.batchSize'),
        flex: 0.8,
        minWidth: 100,
    },
    {
        field: 'isActive',
        headerName: t('studioSyncTableState.isActive'),
        flex: 0.6,
        minWidth: 90,
        valueFormatter: (value: any) => (value ? t('general.yes') : t('general.no')),
    },
    {
        field: 'lastSuccessfulSyncAt',
        headerName: t('studioSyncTableState.lastSuccessfulSyncAt'),
        flex: 1.2,
        minWidth: 160,
        valueFormatter: (value: any) => {
            if (!value) return '-';
            return new Date(value).toLocaleString('tr-TR');
        },
    },
    {
        field: 'lastSourceKey',
        headerName: t('studioSyncTableState.lastSourceKey'),
        flex: 1,
        minWidth: 120,
        valueFormatter: (value: any) => value || '-',
    },
    {
        field: 'updatedAt',
        headerName: t('studioSyncTableState.updatedAt'),
        flex: 1.2,
        minWidth: 160,
        valueFormatter: (value: any) => {
            if (!value) return '';
            return new Date(value).toLocaleString('tr-TR');
        },
    },
];
